
import { Button } from "./Button";
import { getCurrentModal } from "./Modal";

export class BtnOpenRates extends Button {
    init() {
        super.init();

        this.includeComponents({
            'SubscriptionModal': "document@#SubscriptionModal",
        });

        this.on('click', () => this.onOpenRates());

        this.isPreviousModal = this.hasAttr('data-previous-modal');
        if (this.isPreviousModal) {
            this.SubscriptionModal.on('hide.bs.modal', this.showPreviousModal.bind(this));
        }
    }

    onOpenRates() {
        if (this.isPreviousModal) {
            this.prevModal = getCurrentModal();
        }

        this.SubscriptionModal.show()
    }

    showPreviousModal() {
        if (!this.prevModal) return;

        this.prevModal.show();
        this.prevModal = null;
    }
}
